import { COLOR_LTSFC_INFORMATION_BLUE } from '@catapultsports/referee-design-tokens';
import { css } from 'linaria';

export const root = css`
    display: flex;
    align-items: center;
`;

export const itemsLabel = css`
    margin-right: 24px;
`;

export const paginationArrows = css`
    display: inline-flex;
    appearance: none;
    background: transparent;
    position: relative;
    padding: 8px 17px;
    margin-right: 8px;
    border: 1px solid #bfbfbf;
    border-radius: 2px;

    &::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        opacity: 0;
    }

    &:hover {
        border: 2px solid #101010;
        padding: 7px 16px;
    }

    &:focus-visible {
        border: 0;
        padding: 7px 16px;
        border: 2px solid ${COLOR_LTSFC_INFORMATION_BLUE};
        outline: none;
    }

    &[disabled]:hover {
        border: 1px solid #bfbfbf;
        background: transparent;
        padding: 8px 17px;
    }
`;

export const paginationDarkArrow = css`
    color: #fff;

    &:hover {
        border-color: #fff;

        &::after {
            border: 0;
        }
    }

    &:focus-visible {
        background-color: rgba(255, 255, 255, 0.32);
    }

    &[disabled] {
        color: #686868;
        border-color: #686868;
    }

    &[disabled]:hover {
        border-color: #686868;
    }
`;

export const selectItems = css`
    position: relative;
    flex-shrink: 0;
    width: 122px;
`;

export const itemSelect = css`
    cursor: pointer;
    color: #101010;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    font-size: 14px;
    border: 1px solid #666666;
    border-radius: 4px;
    padding: 4px 15px;
    height: 28px;
    margin: 1px;
`;

export const itemSelectActive = css`
    border: 2px solid #101010;
    margin: 0;
`;

export const itemSelectActiveDark = css`
    border-color: #fff;
`;

export const sortByTitle = css`
    color: #a5afb9;
`;

export const dropdownContainer = css`
    background: #ffffff;
    color: #000000;
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14),
        0px 3px 14px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    z-index: 100;
    position: absolute;
    top: -177px;
`;

export const dropdownOption = css`
    cursor: pointer;
    width: 122px;
    padding: 14px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 4px;
    font-size: 14px;

    &:hover {
        background: #ccd2d8;
    }
`;

export const dropdownOptionActive = css`
    background: #ccd2d8;
`;

export const actionPlanItemStack = css`
    margin-top: 16px;
`;

export const sentinel = css`
    height: 8px;
    width: 8px;
`;
